import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import "../../Views/NewAboutus/aboutNew.css"
import weLinkLogo from "../../Views/NewAboutus/aboutNew.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FAVICON_URL, cdnAssetUrl } from "../../config/staticAssets";


function NewAboutus() {
    const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a loading delay (e.g. 2 seconds)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    // Clean up
    return () => clearTimeout(timer);
  }, []);

  // Consolidated scroll listeners with cleanup
  useEffect(() => {
    const onScroll = () => {
      const stickyHeader = document.querySelector('.xb-header-area-sticky');
      const mainHeader = document.querySelector('.new-header-fixed');
      if (!stickyHeader || !mainHeader) return;
      if (window.scrollY > 100) {
        stickyHeader.classList.add('visible');
        mainHeader.classList.add('fade-out');
      } else {
        stickyHeader.classList.remove('visible');
        mainHeader.classList.remove('fade-out');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // ------------------------------------------------------------
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };
  // ---------------------------(Animation of Images )----------------------------------
  useEffect(() => {
    const parallax = () => {
      const scrollY = window.scrollY;
      const moveValue1 = scrollY * 0.3;
      const moveValue2 = scrollY * 0.3;
      const shapeOne = document.querySelector('.newShape-one img');
      const shapeTwo = document.querySelector('.newShape-two img');
      const shapeThree = document.querySelector('.newShape-three img');
      const shapeFour = document.querySelector('.newShape-four img');
      if (shapeOne) shapeOne.style.transform = `translateY(-${moveValue1}px)`;
      if (shapeTwo) shapeTwo.style.transform = `translateY(-${moveValue2}px)`;
      if (shapeThree) shapeThree.style.transform = `translateY(-${moveValue1}px)`;
      if (shapeFour) shapeFour.style.transform = `translateY(-${moveValue2}px)`;
    };
    window.addEventListener('scroll', parallax, { passive: true });
    return () => window.removeEventListener('scroll', parallax);
  }, []);

  // ----------------------(Animation of Images )----------------------------
  // ------------------------(Loading)--------------------------
  useEffect(() => {
    document.body.classList.add('loading');
    window.addEventListener('load', () => {
      document.body.classList.remove('loading');
    });
  }, []);
  // -------------------------(Loading)-------------------------


  return (
    <div>
      <Helmet>
        <link rel="image_src" href={FAVICON_URL} />
        <link rel="shortcut icon" href={FAVICON_URL} type="images/x-icon" />
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/fork-awesome@1.2.0/css/fork-awesome.min.css"
          integrity="sha256-XoaMnoYC5TH6/+ihMEnospgm0J1PM/nioxbOUdnM8HY=" crossorigin="anonymous"></link>
        <link rel="stylesheet" href={cdnAssetUrl("assets/css/bootstrap.min.css")} />
        <link rel="stylesheet" href={cdnAssetUrl("assets/css/fontawesome.css")} />
        <link rel="stylesheet" href={cdnAssetUrl("assets/css/animate.css")} />
        <link rel="stylesheet" href={cdnAssetUrl("assets/css/swiper.min.css")} />
        <link rel="stylesheet" href={cdnAssetUrl("assets/css/odometer.css")} />
        <link rel="stylesheet" href={cdnAssetUrl("assets/css/nice-select.css")} />
        <link rel="stylesheet" href={cdnAssetUrl("assets/css/aos.css")} />
        <link rel="stylesheet" href={cdnAssetUrl("assets/css/jquery-ui.min.css")} />
        <link rel="stylesheet" href={cdnAssetUrl("assets/css/magnific-popup.css")} />
        <link rel="stylesheet" href={cdnAssetUrl("assets/css/rs6.css")} />
        <link rel="stylesheet" href={cdnAssetUrl("assets/css/main.css")} />
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/toastr.js/latest/toastr.min.css"></link>
      </Helmet>

      {/* ✅ Preloader */}
      {loading && (
        <div id="xb-loadding" className="xb-loader">
          <div className="loading-spin"></div>
        </div>
      )}

      {/* ✅ Page content will only show when loader is done */}
      {!loading && (
        <>
          {/* Back to top button */}
          <div className="xb-backtotop">
            <a href="#" className="scroll">
              <i className="far fa-arrow-up"></i>
            </a>
          </div>


          <div className="body_wrap">

            {/* <!-- header start --> */}
            <header id="xb-header-area" className="site-header header-default is-sticky">
              {/* <!-- Fixed Navbar (hidden until scroll) --> */}
              <div className="xb-header__wrap  xb-header new-header-fixed">
                <div className="container mxw_1710 new-header-Cont">
                  <div className=" Header-InnerContainer">
                    <div className="xb-header__logo">
                      <a href="/Newaboutus">
                        <img src={cdnAssetUrl("assets/welink.79ac1260.svg")} alt="Logo" />
                      </a>
                    </div>

                    <div className="main-menu__wrap ul_li navbar navbar-expand-lg header-fixed">

                      <nav className="main-menu collapse navbar-collapse">
                        <ul>

                          <li className=""><a href="/Newaboutus"><span>About</span></a></li>
                          <li className=""><a href="https://welinkjobs.com/blogs"
                            target="_blank"><span>Blogs</span></a></li>
                          <li className="menu-item"><a href="/Newaboutus#contactform"><span>Contact</span></a>
                          </li>
                          <li className=""><a href="faq.html"><span>FAQs</span></a></li>
                          <li className="active"><a href="downlaodapp.html"><span>Download App</span></a></li>
                        </ul>
                      </nav>

                      {/* <!-- mobile navbar --> */}
                      <div className="xb-header-wrap">
                        <div className="xb-hamburger-menu">
                          <div className="xb-nav-mobile" onClick={handleMenuToggle}>
                            <div className="xb-nav-mobile-button">
                              <FontAwesomeIcon icon={faBars} />
                            </div>
                          </div>
                        </div>

                        <div className={`xb-header-menu ${menuOpen ? "active" : ""}`}>
                          <div className="xb-header-menu-scroll">
                            <div className="xb-menu-close xb-hide-xl xb-close" onClick={handleCloseMenu}>
                              {/* X */}
                            </div>

                            <div className="xb-logo-mobile xb-hide-xl">
                              <a href="/Newaboutus" rel="home">
                                <img src={cdnAssetUrl("assets/welink.79ac1260.svg")} alt="Logo" />
                              </a>
                            </div>

                            <nav className="xb-header-nav">
                              <ul className="xb-menu-primary clearfix">
                                <li className="menu-item">
                                  <a href="/Newaboutus">
                                    <span>About</span>
                                  </a>
                                </li>
                                <li className="menu-item">
                                  <a href="https://welinkjobs.com/blogs" target="_blank" rel="noreferrer">
                                    <span>Blogs</span>
                                  </a>
                                </li>
                                <li className="menu-item">
                                  <a href="/Newaboutus#contactform">
                                    <span>Contact</span>
                                  </a>
                                </li>
                                <li className="menu-item">
                                  <a href="faq.html">
                                    <span>FAQs</span>
                                  </a>
                                </li>
                                <li className="menu-item">
                                  <a href="downlaodapp.html">
                                    <span>Download App</span>
                                  </a>
                                </li>
                                <li className="menu-item">
                                  <a href="https://welinkjobs.com/NewsFeed" target="_blank" rel="noreferrer">
                                    Explore
                                  </a>
                                </li>
                                <li className="menu-item">
                                  <a href="https://welinkjobs.com/signIn" target="_blank" rel="noreferrer">
                                    LOGIN / SIGNUP
                                  </a>
                                </li>
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>

                      {menuOpen && (
                        <div className="xb-header-menu-backdrop" onClick={handleCloseMenu}></div>
                      )}
                    </div>
                    <div className="xb-header__btn Header-above">
                      <a className="xb-btn new-x-btn" href="https://welinkjobs.com/NewsFeed" target="_blank">EXPLORE</a>
                      <a className="xb-btn new-x-btn" href="https://welinkjobs.com/signIn" target="_blank">LOGIN /
                        SIGNUP</a>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Sticky Navbar (show until scroll) --> */}
              <div className="xb-header__wrap xb-header xb-header-area-sticky">
                <div className="container mxw_1710 new-header-Cont">
                  <div className="Header-InnerContainer">
                    <div className="xb-header__logo">
                      <img src={cdnAssetUrl("assets/welink.79ac1260.svg")} alt="Logo" />
                    </div>
                    <div className="main-menu__wrap ul_li navbar navbar-expand-lg header-fixed">
                      <nav className="main-menu collapse navbar-collapse">
                        <ul>
                          <li><a href="/Newaboutus"><span>About</span></a></li>
                          <li><a href="https://welinkjobs.com/blogs" target="_blank"><span>Blogs</span></a></li>
                          <li><a href="/Newaboutus#contactform"><span>Contact</span></a></li>
                          <li><a href="faq.html"><span>FAQs</span></a></li>
                          <li className="active"><a href="downlaodapp.html"><span>Download App</span></a></li>
                        </ul>
                      </nav>
                    </div>

                    {/* <!-- mobile navbar --> */}
                    <div className="xb-header-wrap">
                      <div className="xb-hamburger-menu">
                        <div className="xb-nav-mobile" onClick={handleMenuToggle}>
                          <div className="xb-nav-mobile-button">
                            <FontAwesomeIcon icon={faBars} />
                          </div>
                        </div>
                      </div>

                      <div className={`xb-header-menu ${menuOpen ? "active" : ""}`}>
                        <div className="xb-header-menu-scroll">
                          <div className="xb-menu-close xb-hide-xl xb-close" onClick={handleCloseMenu}>
                            {/* X */}
                          </div>

                          <div className="xb-logo-mobile xb-hide-xl">
                            <a href="aboutus.html" rel="home">
                              <img src={cdnAssetUrl("assets/welink.79ac1260.svg")} alt="Logo" />
                            </a>
                          </div>

                          <nav className="xb-header-nav">
                            <ul className="xb-menu-primary clearfix">
                              <li className="menu-item">
                                <a href="aboutus.html">
                                  <span>About</span>
                                </a>
                              </li>
                              <li className="menu-item">
                                <a href="https://welinkjobs.com/blogs" target="_blank" rel="noreferrer">
                                  <span>Blogs</span>
                                </a>
                              </li>
                              <li className="menu-item">
                                <a href="aboutus.html#contactform">
                                  <span>Contact</span>
                                </a>
                              </li>
                              <li className="menu-item">
                                <a href="faq.html">
                                  <span>FAQs</span>
                                </a>
                              </li>
                              <li className="menu-item">
                                <a href="downlaodapp.html">
                                  <span>Download App</span>
                                </a>
                              </li>
                              <li className="menu-item">
                                <a href="https://welinkjobs.com/NewsFeed" target="_blank" rel="noreferrer">
                                  Explore
                                </a>
                              </li>
                              <li className="menu-item">
                                <a href="https://welinkjobs.com/signIn" target="_blank" rel="noreferrer">
                                  LOGIN / SIGNUP
                                </a>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>

                      <div className="xb-header__btn Header-Sticky">
                        <a className="xb-btn new-x-btn" href="https://welinkjobs.com/NewsFeed" target="_blank">EXPLORE</a>
                        <a className="xb-btn new-x-btn" href="https://welinkjobs.com/signIn" target="_blank">LOGIN /
                          SIGNUP</a>
                      </div>
                    </div>

                    {menuOpen && (
                      <div className="xb-header-menu-backdrop" onClick={handleCloseMenu}></div>
                    )}
                    {/* <!-- mobile navbar --> */}

                  </div>
                </div>
              </div>

            </header>
            {/* <!-- header end --> */}


            <div className="body-overlay"></div>
            <main>
              {/* first one Start*/}
              <section className="hero hero-default ul_li bg_img col-xl-12 col-lg-12" data-bg-color="#E7">
                <div>
                  <img src={cdnAssetUrl("assets/imagesforportal/social-interaction-concept-3d-render.jpg")} alt="" />
                </div>

                <div className="hero-content">
                  <div className="sec-title mb-40 ">
                    <h1 className="title title-big gradient-text titlealign">
                      Search And Apply For <br /> Jobs Globally
                    </h1>
                  </div>
                  {/* <div>
                <button> <a href="/Newaboutus">Click to check New React</a></button>
              </div> */}
                </div>
              </section>
              {/* first one End*/}


              {/* second started */}
              <section class="about pt-45 pb-50">
                <div className='about-mainContainer'>
                  <div className='col-lg-6'>
                    <div class="sec-title about-sec-title">
                      <h2 class="title mb-35">About Us</h2>
                      <p class="mb-25">Nowadays the marketplace and the growing companies are facing real
                        challenges to find the right talent. Most importantly, the companies need to
                        understand the facilities a global recruitment platform can offer.</p>
                      <p>Welcome to Welinkjobs, the Competitive and interactive network which globally
                        involves you to achieve a better opportunity. Moreover in Welinkjobs, companies
                        can immediately hire new team members in a competitive advantage through an easy
                        search engine all in one platform.</p>
                    </div>


                    <div className='about-small-Overview'>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mt-30">
                        <div class="xb-mission about-Overview">
                          <div class="xb-item--icon about-smallImg">
                            <img src={cdnAssetUrl("assets/img/icon/ms_01.png")} alt="" />
                          </div>
                          <div class="xb-item--holder">
                            <h3 class="xb-item--title about-header-Overview">Our Mission</h3>
                            <p className='about-para-Overview'>Connect all the members
                              globally to find better
                              solutions for career path</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mt-30">
                        <div class="xb-mission about-Overview">
                          <div class="xb-item--icon about-smallImg">
                            <img src={cdnAssetUrl("assets/img/icon/ms_02.png")} alt="" />
                          </div>
                          <div class="xb-item--holder">
                            <h3 class="xb-item--title about-header-Overview">Our Vision</h3>
                            <p className='about-para-Overview'>Create a comprehensive
                              opportunity for every
                              workforce in the world</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="col-lg-6 about-career-growth">
                    <img src={cdnAssetUrl("assets/img/about/career_growth_concept.png")} alt="" />
                  </div>

                </div>
              </section>
              {/* second Ended */}

              {/* Third started */}
              <section
                class="feature feature-pb feature-section"
                style={{
                  "--feature-bg-image": `url("${cdnAssetUrl("assets/img/bg/feat_bg.jpg")}")`,
                }}
              >
                <div className='feature-main-container'>
                  <div class="col-xl-4 col-lg-4 mt-30" >
                    <div class="">
                      <span class="subtitle-feature">
                        <img src={cdnAssetUrl("assets/img/icon/hr_icon.png")} alt="" />
                        &nbsp; Find
                        Your Perfect Fit</span>
                      <h2 class="title feature-title">Let us be <br /> the bridge <br /> between <br /> you and your <br />
                        ideal career <br />  opportunity</h2>
                      <h2 class="title"></h2>

                    </div>
                  </div>

                  <div class="col-xl-5 offset-xl-3 col-lg-6 offset-lg-2  feature-main-item" data-aos-duration="900" data-aos-delay="200">
                    <div className=''>
                      <div className='feature-item-partone'>
                        {/* <div> */}
                        <div class="xb-feature xb-feature2 mt-70">
                          <div class="xb-item--icon">
                            <img src={cdnAssetUrl("assets/img/icon/tech-icon1.png")} alt="" />
                          </div>
                          <h3 class="xb-item--title">Technology</h3>
                          <p class="xb-item--content">Including roles in software development, IT support, and
                            cybersecurity.</p>
                        </div>

                        {/* </div> */}

                        <div class="xb-feature xb-feature2 mt-70">
                          <div class="xb-item--icon">
                            <img src={cdnAssetUrl("assets/img/icon/healthcare1.png")} alt="" />
                          </div>
                          <h3 class="xb-item--title">Facility Management</h3>
                          <p class="xb-item--content">Including role in Production
                            Manager,MEP Supervisor, Soft Servics Manager, Maintenance Manager.</p>
                        </div>
                      </div>

                      <div className='feature-item-parttwo'>
                        <div class="xb-feature xb-feature2 mt-80">
                          <div class="xb-item--icon">
                            <img src={cdnAssetUrl("assets/img/icon/education1.png")} alt="" />
                          </div>
                          <h3 class="xb-item--title">Education</h3>
                          <p class="xb-item--content">Teaching positions,
                            administrative roles, and educational support staff.</p>
                        </div>

                        <div class="xb-feature xb-feature2 mt-80">
                          <div class="xb-item--icon">
                            <a href="https://welinkjobs.com/SearchJob">
                              <img src={cdnAssetUrl("assets/img/icon/search1.png")} alt="" />
                            </a>
                          </div>
                          <a href="https://welinkjobs.com/SearchJob">
                            <h3 class="xb-item--title">Search More</h3>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </section>
              {/* Third Ended */}



              {/* <!-- cta start --> */}
              <section class="fanfact fanfact-cta">
                {/* <video class="fanfact-video" src="" loop autoplay muted>
              <source src={cdnAssetUrl("assets/img/about/newabout.mp4")} type="video/mp4"></source>
            </video> */}
                <video
                  className="fanfact-video"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source src={cdnAssetUrl("assets/img/about/newabout.mp4")} type="video/mp4" />
                </video>

                <section class="cta z-1 pos-rel" data-bg-color="#E7E9EE">
                  <div class="container px-60 post-vidContainer">
                    <div class="xb-cta  MobWhat-secttion">
                      <div
                        class=" MobWhat-Main-content"
                        style={{
                          "--cta-shadow-image": `url("${cdnAssetUrl("assets/img/shape/cta_shadow.png")}")`,
                        }}
                      >
                        <div class="mobilemb-main">
                          <div class="xb-icon-img ul_li mobilemb ">
                            <a href="tel:+13072436345" class="icon-link">
                              <div class="icon">
                                <i class="fas fa-phone"></i>
                              </div>
                            </a>
                          </div>

                          <h3 class="xb-item--number">+1 3072436345</h3>
                        </div>

                        <div class="whatapp-main">
                          <p class="xb-item--content">Use our Hotline for quick get <br />  in touch for 24 hours
                          </p>

                          <div class="xb-icon-img ul_li mobilemt ">
                            <a href="https://wa.me/+13072436345" target="_blank" class="icon-link">
                              <div class="icon">
                                <i class="fab fa-whatsapp"></i>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </section>
              {/* <!-- cta end --> */}

              {/* <!-- services start --> */}
              <section class="services services-part-container">
                <div class="container services-content">
                  <div class="row justify-content-center g-12 mt-none-12">

                    <div class="col-lg-4 col-md-6">

                      <div class="xb-service xb-service1 mt-12">
                        <div class="xb-service__sec-title mt-12 ">
                          <div class="sec-title">
                            <span class="subtitle ul_li d-none"><img src={cdnAssetUrl("assets/img/icon/hr_icon.png")} alt="" />
                              Service By Our Features
                            </span>
                            <h4 class=" mb-20">Job Search and Application:</h4>
                            <p> Users can search for and apply to job opportunities globally through an
                              interactive platform</p>
                          </div>

                        </div>
                      </div>

                      <div class="xb-service xb-service1 mt-12">
                        <div class="">


                          <div class="xb-item--shape">

                          </div>
                          <img src={cdnAssetUrl("assets/imagesforportal/complexities-hrm-through-compelling-graphic-featuring-magnifier-glass-zooming-man.jpg")}
                            alt="" />
                        </div>
                      </div>
                    </div>


                    <div class="col-lg-4 col-md-6">
                      <div class="xb-service xb-service1 mt-12">
                        <div class="xb-item--inner">
                          <div class="xb-item--icon">
                            <img src={cdnAssetUrl("assets/img/icon/srv_01.svg")} alt="" />
                          </div>
                          <h3 class="xb-item--title"><a href="#">Company Profiles:</a></h3>
                          <p class="xb-item--content">Employers can create detailed profiles to attract
                            potential candidates</p>
                          <div class="xb-item--shape">
                            <img src={cdnAssetUrl("assets/img/shape/srv_shape.png")} alt="" />
                          </div>
                          <a class="xb-overlay"></a>
                        </div>
                      </div>
                      <div class="xb-service xb-service1 mt-12">
                        <div class="xb-item--inner">
                          <div class="xb-item--icon">
                            <img src={cdnAssetUrl("assets/img/icon/srv_03.svg")} alt="" />
                          </div>
                          <h3 class="xb-item--title"><a href="#">Resume Building:</a></h3>
                          <p class="xb-item--content">Tools and templates to help users create professional
                            resumes</p>
                          <div class="xb-item--shape">
                            <img src={cdnAssetUrl("assets/img/shape/srv_shape.png")} alt="" />
                          </div>
                          <a class="xb-overlay"></a>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                      <div class="xb-service xb-service1 mt-12">
                        <div class="xb-item--inner">
                          <div class="xb-item--icon">
                            <img src={cdnAssetUrl("assets/img/icon/srv_02.svg")} alt="" />
                          </div>
                          <h3 class="xb-item--title"><a href="#">Job Alerts:</a></h3>
                          <p class="xb-item--content">Personalized job alerts based on user preferences and
                            search history</p>
                          <div class="xb-item--shape">
                            <img src={cdnAssetUrl("assets/img/shape/srv_shape.png")} alt="" />
                          </div>
                          <a class="xb-overlay"></a>
                        </div>
                      </div>
                      <div class="xb-service xb-service1 mt-12">
                        <div class="xb-item--inner">
                          <div class="xb-item--icon">
                            <img src={cdnAssetUrl("assets/img/icon/srv_04.svg")} alt="" />
                          </div>
                          <h3 class="xb-item--title"><a href="#"> Networking:</a></h3>
                          <p class="xb-item--content">Opportunities to connect with industry professionals and
                            other job seekers</p>
                          <div class="xb-item--shape">
                            <img src={cdnAssetUrl("assets/img/shape/srv_shape.png")} alt="" />
                          </div>
                          <a class="xb-overlay"></a>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                      <div class="xb-service xb-service1 mt-12">
                        <div class="xb-item--inner">
                          <div class="xb-item--icon">
                            <img src={cdnAssetUrl("assets/img/icon/srv_05.svg")} alt="" />
                          </div>
                          <h3 class="xb-item--title"><a href="#">Interview Preparation: </a></h3>
                          <p class="xb-item--content">Resources and tips to help users prepare for job
                            interviews</p>
                          <div class="xb-item--shape">
                            <img src={cdnAssetUrl("assets/img/shape/srv_shape.png")} alt="" />
                          </div>
                          <a class="xb-overlay"></a>
                        </div>
                      </div>

                      <div class="xb-service xb-service1 mt-12">
                        <div class="xb-item--inner">
                          <div class="xb-item--icon">
                            <img src={cdnAssetUrl("assets/img/icon/srv_06.svg")} alt="" />
                          </div>
                          <h3 class="xb-item--title"><a href="#">Application Tracking: </a></h3>
                          <p class="xb-item--content">Tools to help users keep track of their job applications
                            and their status.</p>
                          <div class="xb-item--shape">
                            <img src={cdnAssetUrl("assets/img/shape/srv_shape.png")} alt="" />
                          </div>
                          <a class="xb-overlay"></a>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="xb-service__shape">
                  <div class="shape shape--1 newShape-one">
                    <img src={cdnAssetUrl("assets/img/shape/srv_shape1.png")} alt="" />
                  </div>
                  <div class="shape shape--2 newShape-two">
                    <img src={cdnAssetUrl("assets/img/shape/srv_shape2.png")} alt="" />
                  </div>
                </div>
              </section>
              {/* <!-- services end --> */}

              {/* <!-- contact start --> */}
              <section class="contact  my-contact-class" id="contactform">
                <div class="container px-60">
                  <div class="xb-contact__wrap">
                    <div class="row">
                      <div class="col-lg-8">
                        <div class="xb-contact__inner">
                          <div class="sec-title mb-45">
                            <span class=" ul_li"><img src={cdnAssetUrl("assets/img/icon/hr_icon.png")} alt="" />&nbsp; Get In
                              Touch With Us</span>
                            <h2 class="title">Contact us </h2>
                          </div>
                          <form action="#" class="xb-contact">
                            <div class="row">
                              <div class="col-lg-6">
                                <div class="xb-item--field">
                                  <span><img src={cdnAssetUrl("assets/img/icon/ins_user.svg")} alt="" /></span>
                                  <input type="text" id="name" placeholder="Name" required />
                                </div>
                              </div>
                              <div class="col-lg-6">
                                <div class="xb-item--field">
                                  <span><img src={cdnAssetUrl("assets/img/icon/ins-sms-tracking.svg")} alt="" /></span>
                                  <input type="email" id="email" placeholder="Email Address" required />
                                </div>
                              </div>
                              {/* <!-- <div class="col-lg-6">
                            <div class="xb-item--field">
                              <span><img src={cdnAssetUrl("assets/img/icon/call-calling.svg")} alt="" /></span>
                              <input type="text" id="phone" placeholder="Phone No." required
                                maxlength="10">
                            </div>
                          </div> --> */}

                              <div class="col-lg-12">
                                <div class="xb-item--field">
                                  <span><img src={cdnAssetUrl("assets/img/icon/ins-home-hashtag.svg")} alt="" /></span>

                                  <select name="subject" id="subject" class="nice-select" required>
                                    <option value="">Select Subject</option>
                                    <option value="Change Account Type">Change Account Type</option>
                                    <option value="Update Your Account Details">Update Your Account
                                      Details</option>
                                    <option value="Sign in with a social account">Sign In With
                                      Social Account</option>
                                    <option value="Regain access to your account">Regain Access to
                                      Your Account</option>
                                    <option value="Forgot Your Password">Forgot Your Password
                                    </option>
                                    <option value="Forgot Your Username">Forgot Your Username
                                    </option>
                                    <option value="Activate Suspended Account">Activate Suspended
                                      Account</option>
                                    <option value="Other">Other</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-lg-12">
                                <div class="xb-item--field">
                                  <span><img src={cdnAssetUrl("assets/img/icon/messages-2.svg")} alt="" /></span>
                                  <textarea name="message" id="message" cols="30" required rows="10"
                                    placeholder="Write you message"></textarea>
                                </div>
                              </div>
                              <div class="col-lg-12">
                                <div class="xb-item--field">
                                  <button class="xb-btn w-100" id="submitRequestButton">Submit your
                                    Request</button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    {/* <!-- <div class="xb-contact__shape">
                  <img src={cdnAssetUrl("assets/img/shape/cnt_shape.png")} alt="">
                </div> --> */}
                    <div class="xb-contact__img">
                      {/* <!-- <img src={cdnAssetUrl("assets/img/bg/cnt_img.png")} alt=""> -->
                    <!-- <img src={cdnAssetUrl("assets/imagesforportal/contact-2.jpg")} alt=""> --> */}
                      <img src={cdnAssetUrl("assets/imagesforportal/contact-1.PNG")} alt=""
                      // style="margin-bottom: 106px;"
                      />
                    </div>
                  </div>
                </div>
                <div class="contact-shape">
                  <div class="shape shape--1 newShape-three">
                    <img src={cdnAssetUrl("assets/img/shape/cnt_shape2.png")} alt="" />
                  </div>
                  <div class="shape shape--2 newShape-four">
                    <img src={cdnAssetUrl("assets/img/shape/cnt_shape3.png")} alt="" />
                  </div>
                </div>
              </section>
              {/* <!-- contact end --> */}

            </main>

            {/* <!-- footer start --> */}
            <footer class="xb-footer   footer-style-one my-footer-class">
              <div class="new-container">
                <div class="footer-cta ul_li_between">
                  <div class="footer-cta__inner ul_li mt-30">
                    <div class="xb-icon-img style-2 ul_li mr-35 icon-center-mobile">
                      <a href="mailto:info@welinkjobs.com" class="icon-link">
                        <div class="icon">
                          <i class="fas fa-envelope "></i>
                        </div>
                      </a>
                    </div>


                    <div class="footer-cta__holder">
                      <span>Drop here a note</span>
                      <h3>info@welinkjobs.com</h3>
                    </div>
                  </div>
                  <div class="footer-cta__inner ul_li mt-30">
                    <div class="xb-icon-img style-2 ul_li mr-35 icon-center-mobile">
                      <a href="tel:+13072436345" class="icon-link">
                        <div class="icon">
                          <i class="fas fa-phone"></i>
                        </div>
                      </a>
                    </div>


                    <div class="footer-cta__holder">
                      <span>Call us Directly</span>
                      <h3>+1 3072436345</h3>
                    </div>
                  </div>



                  <span class="footer-cta__line"></span>
                </div>
                <div class="footer-main mt-12">
                  <div class="mt-none-40 d-flex justify-content-between">
                    <div class="footer-col mt-40">
                      <div class="footer-widget">
                        <ul class="widget-links list-unstyled">
                          <li><a href="aboutus.html">About Us</a></li>
                          <li><a href="aboutus.html#contactform">Contact Us</a></li>
                        </ul>
                      </div>
                    </div>
                    <div class="footer-col mt-40">
                      <div class="footer-widget">
                        <ul class="widget-links list-unstyled">
                          <li><a href="privacy-policy.html">Privacy Policy</a></li>
                          <li><a href="faq.html">FAQs</a></li>
                        </ul>
                      </div>
                    </div>
                    <div class="footer-col mt-40">
                      <div class="footer-widget">
                        <ul class="widget-links list-unstyled">
                          <li><a href="terms-and-conditions.html">Terms and Conditions</a></li>
                          <li><a href="user-agreement.html">User Agreement</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="footer-copyright ul_li_between mt-12">
                  <p class="mt-15">Copyright © <a href="https://welinkjobs.com/">Welinkjobs LLC</a>. All rights
                    reserved.</p>
                </div>
              </div>
              <div class="footer-shape">
                <div class="shape shape--1">
                  <img data-parallax='{"y": "-80"}' src={cdnAssetUrl("assets/img/shape/ft_shape1.png")} alt="" />
                </div>
                <div class="shape shape--2">
                  <img data-parallax='{"y": "80"}' src={cdnAssetUrl("assets/img/shape/ft_shape2.png")} alt="" />
                </div>
              </div>
            </footer>
            {/* <!-- footer start --> */}

          </div>
        </>
      )}

    </div >
  )
}

export default NewAboutus
